<template>
    <div>Welcome to ARKI</div>
    <dx-button
        v-for="button in buttons"
        v-bind:key="button.name"
        :hint="button.name"
        @click="redirectTo(button.url)"
    >{{ button.name }}
    </dx-button>
</template>

<script>
export default {
    name: 'arki-home-view',
};
</script>

<script setup>
import { onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { DxButton } from 'devextreme-vue';

import { homeButtons, baseUrl, appName } from '@/views/arki/services/arki-service';

const
    router = useRouter(),
    route = useRoute(),
    buttons = homeButtons;

onMounted(() => {
});

const redirectTo = (url) => {
    const { app, dep } = route.params;
    router.push({ path: `/${baseUrl}/${appName}/${url}/&/${app}/${dep}` });
};

</script>

<style scoped>

</style>
